import { request } from 'Lib/axios'
import { useQuery } from '@tanstack/react-query'
import { ExtractFnReturnType } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { Domain } from 'Types/Domain'
import { PaginationMetadata, PaginationRequest } from 'Types/Pagination'
import { buildPaginationQueryString } from 'Utils/pagination'

export type GetDomainsMetadaResponse =
  | (PaginationMetadata & {
      totalPmDomains?: number
      totalBmDomains?: number
    })
  | undefined

type GetDomainsResponse = {
  domains: Array<Domain>
  metadata?: GetDomainsMetadaResponse
}

type QueryFnType = typeof getDomains

export const useGetDomains = (pagination?: PaginationRequest) => {
  const { accountId, userId, subscriptionId } = useUserStore.getState()

  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['domains', userId, pagination?.page, pagination?.search],
    enabled: !!accountId && !!subscriptionId,
    queryFn: () => getDomains(userId, accountId, pagination),
    // polling: refetch every five minutes
    refetchInterval: 1000 * 60 * 5,
  })

  const data = query.data && query.data instanceof Error ? undefined : query.data

  return { ...query, data }
}

const getDomains = async (userId: number, accountId: number, pagination?: PaginationRequest) => {
  const queryString = buildPaginationQueryString(pagination)

  return await request<{ data: GetDomainsResponse }>({
    url: `users/${userId}/accounts/${accountId}/domains${queryString}`,
    method: 'GET',
  })
}
